<template>
	<div class="panel-header">
		<t-icon-button
			v-if="useButton"
			:type="type"
			:icon="icon"
			:iconSize="size"
			:color="color"
			appearance="minimal"
			v-on="$listeners"
		/>
		<t-timpex-icon
			v-else
			:type="type"
			:icon="icon"
			:size="size"
			:color="color"
		/>
		<div class="panel-header-content" :class="textSize">
			<slot>{{text}}</slot>
		</div>
	</div>
</template>

<script>
import TTimpexIcon from '../icons/TTimpexIcon';
export default {
	name: 'TPanelHeader',
	components: { TTimpexIcon },
	props: {
		icon: String,
		type: String,
		text: [ String, Number ],
		size: String,
		color: { type: String, default: 'blue' },
		textSize: { type: String, default: 'medium' },

	},
	computed: {
		useButton() {
			return this.$listeners.click;
		},
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.panel-header {
	display: flex;
	overflow: visible;
	align-items: center;
}
.panel-header-content {
	@extend %font-families-ui;
	@extend %text-medium;
	color: get-color($text, 'default');
	font-weight: 500;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	margin: 0px 8px;
	flex: 1;
	user-select: none;
	&.large {
		@extend %text-large;
		color: get-color($neutral-scale, 'N10');
		font-weight: 500;
	}
}

</style>

<docs>
```jsx
<t-panel-header icon="order" text="Order" size="md"/>
```
</docs>